const state = {
    showSidebar: JSON.parse(localStorage.getItem('showSidebar')) || false,
    sidebarLinks: [],
    expandedGroups:
        JSON.parse(localStorage.getItem('sidebarExpandedGroups')) || {},
    displaySidebar(value) {
        this.showSidebar = value;
        localStorage.setItem('showSidebar', JSON.stringify(value));
    },
};

const mutations = {
    TOGGLE_SIDEBAR(state) {
        state.showSidebar = !state.showSidebar;
        localStorage.setItem('showSidebar', JSON.stringify(state.showSidebar));
    },
    SET_SIDEBAR(state, value) {
        state.showSidebar = value;
        localStorage.setItem('showSidebar', JSON.stringify(state.showSidebar));
    },
    SET_SIDEBAR_LINKS(state, links) {
        state.sidebarLinks = links;
    },
    SET_GROUP_EXPANDED(state, { id, expanded }) {
        state.expandedGroups = {
            ...state.expandedGroups,
            [id]: expanded,
        };
        localStorage.setItem(
            'sidebarExpandedGroups',
            JSON.stringify(state.expandedGroups)
        );
    },
};

const actions = {
    toggleSidebar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    setSidebar({ commit }, value) {
        commit('SET_SIDEBAR', value);
    },
    setSidebarLinks({ commit }, links) {
        commit('SET_SIDEBAR_LINKS', links);
    },
    setGroupExpanded({ commit }, payload) {
        commit('SET_GROUP_EXPANDED', payload);
    },
};

const getters = {
    showSidebar: state => state.showSidebar,
    sidebarLinks: state => state.sidebarLinks,
    expandedGroups: state => state.expandedGroups,
    isGroupExpanded: state => id => !!state.expandedGroups[id],
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
